import React, { useEffect, useRef } from "react";
import Layout from "../../../components/admin/Layout";
import Helmet from "react-helmet";
import Table from "../../../components/ui/Table";
import usePaginate from "../../../hooks/api/usePaginate";
import apiRequest from "../../../utils/admin/apiRequest";
import useModal from "../../../hooks/ui/useModal";
import Pagination from "../../../components/ui/Pagination";
import { FaEdit, FaPlus, FaTrashAlt } from "react-icons/fa";
import Modal from "../../../components/ui/utils/Modal";
import Button from "../../../components/ui/utils/Button";
import useFormInput from "../../../hooks/form/useFormInput";
import { useSelector } from "react-redux";

import InputField from "../../../components/ui/form/InputField";
import CreateAdmin from "../../../components/admin/admin/CreateAdmin";
import EditAdmin from "../../../components/admin/admin/EditAdmin";
import DeleteAdmin from "../../../components/admin/admin/DeleteAdmin";
import CreateStaffAdmin from "../../../components/admin/admin/staffAdmin/CreateStaffAdmin";

const Admin = () => {
    const {
        currentPage,
        data,
        error,
        fetchData,
        limit,
        loading,
        setPage,
        setSorting,
        sort,
        totalItems,
        totalPages,
        setFilters,
    } = usePaginate({
        apiMethod: apiRequest.getAdmin,
        dataKey: "admins",
    });


    const { isOpen, openModal, closeModal, actionType } = useModal();
    const handleSort = (field) => {
        const order = sort.sortField === field && sort.sortOrder === "asc" ? "desc" : "asc";
        setSorting({ sortField: field, sortOrder: order });
    };


    const searchInitialValues = { name: "" };
    const { values, handleChange, setValues } = useFormInput(searchInitialValues);
    const debounceRef = useRef(null);

    useEffect(() => {
        if (values.name !== undefined) {
            if (debounceRef.current) {
                clearTimeout(debounceRef.current);
            }
            debounceRef.current = setTimeout(() => {
                const filters = {};
                filters.type = "adminHead";
                if (values.name) {
                    filters.name = { $regex: values.name, $options: "i" };
                }
                setFilters(filters);
            }, 500);
            return () => clearTimeout(debounceRef.current);
        }
    }, [values.name]);




    const BRAND_NAME = useSelector(
        (state) => state.globalState?.siteSetting?.site_settings?.site_name
    );



    return (
        <Layout>
            <Helmet>
                <title>Admin - {BRAND_NAME ?? ''}</title>
            </Helmet>

            <div className="p-4 bg-white rounded">
                <div className="flex items-center gap-1 py-2">
                    <Button
                        onClick={() => openModal({ type: "add" })}
                        variant="primary"
                        isLoading={false}
                    >
                        <div className="flex items-center justify-center gap-3">
                            <FaPlus />
                            <p>Add Admin Head</p>
                        </div>
                    </Button>
                  


                </div>
                <div className="grid grid-cols-1 sm:grid-cols-[1fr_100px] gap-2 my-2">
                    <InputField
                        name="name"
                        placeholder="e.g. search by name ...."
                        value={values.name}
                        onChange={handleChange}
                    />
                    <button
                        className="py-1 text-white rounded bg-emerald-600 hover:bg-emerald-800"
                        onClick={() => setValues(searchInitialValues)}
                    >
                        Clear
                    </button>
                </div>

                <Table
                    headers={[
                        { label: "Name", key: "name", sorting: true },
                        { label: "Mobile", key: "mobile", sorting: false },
                        { label: "User Id", key: "userId", sorting: false },
                        { label: "City", key: "city", sorting: true },
                        { label: "Admin Count", key: "adminCount", sorting: true },
                        { label: "Created At", key: "createdAt", sorting: true },
                        {
                            label: "Action",
                            key: "action",
                            sorting: false,
                        },
                    ]}
                    loading={loading}
                    handleSort={handleSort}
                    sort={sort}
                    error={error}
                    cols={7}
                    renderRow={
                        <tbody className="bg-white divide-y divide-gray-200">
                            {data?.map((vendor) => {

                                return (
                                    <tr key={vendor._id} className="transition-colors hover:bg-gray-50">
                                        <td className="px-3 py-3">
                                            <span className="font-semibold capitalize text-gray-800">{vendor.name}</span>
                                        </td>
                                           <td className="px-3 py-3">
                                            <span className="text-xs text-gray-500">{vendor.mobile}</span>
                                        </td>
                                        <td className="px-3 py-3">
                                              <span className="text-xs text-gray-500">{vendor?.userId}</span>
                                        </td>

                                        <td className="px-3 py-3">
                                            <span className="text-xs text-gray-500">{vendor?.cityId?.name}</span>
                                        </td>
                                     
                                        <td className="px-3 py-3">
                                            {vendor?.staffCount}
                                        </td>
                                        <td className="px-3 py-3">
                                            <span className="text-xs text-gray-400">
                                                {new Date(vendor.createdAt).toLocaleDateString()}
                                            </span>
                                        </td>
                                        <td className="px-3 py-3">
                                            <div className="flex justify-center gap-3">
                                                <button
                                                    onClick={() => openModal({ type: "admin", data: { state: vendor } })}
                                                    className="text-primary bg-emerald-100 p-2 rounded-full hover:bg-emerald-500 hover:text-white"
                                                    title="Edit"
                                                >
                                                    <p className=""> <FaPlus size={18} /></p>
                                                </button>

                                                <button
                                                    onClick={() => openModal({ type: "edit", data: { state: vendor } })}
                                                    className="text-primary"
                                                    title="Edit"
                                                >
                                                    <FaEdit size={18} />
                                                </button>
                                                <button
                                                    onClick={() => openModal({ type: "delete", data: { state: vendor } })}
                                                    className="text-red-500"
                                                    title="Delete"
                                                >
                                                    <FaTrashAlt size={18} />
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    }
                />
                {totalPages > 1 && (
                    <Pagination
                        pagination={{
                            currentPage,
                            totalPages,
                            totalItems: totalItems,
                            perPage: limit,
                        }}
                        handlePageChange={setPage}
                        loading={loading}
                    />
                )}
            </div>
            <Modal isOpen={isOpen} onClose={closeModal} size="large">

                {actionType?.type === "admin" && (
                    <CreateStaffAdmin data={actionType?.data?.state} closeModal={closeModal} callback={fetchData} />
                )}

                {actionType?.type === "add" && (
                    <CreateAdmin closeModal={closeModal} callback={fetchData} />
                )}
                {actionType?.type === "edit" && (
                    <EditAdmin
                        data={actionType?.data?.state}
                        closeModal={closeModal}
                        callback={fetchData}
                    />
                )}
                {actionType?.type === "delete" && (
                    <DeleteAdmin
                        data={actionType?.data?.state}
                        closeModal={closeModal}
                        callback={fetchData}
                    />
                )}
            </Modal>
        </Layout>
    );
};

export default Admin;
